// extracted by mini-css-extract-plugin
export const main = "styles-module--main--26QFq";
export const inputWrapper = "styles-module--inputWrapper--2bcvH";
export const searchIcon = "styles-module--searchIcon--321fU";
export const clearIcon = "styles-module--clearIcon--38JdN";
export const articleList = "styles-module--articleList--PcQ8h";